<script>
export default {
    props: {
        disabled: Boolean
    },
    computed: {
        btnClass() {
            if (this.disabled) {
                return 'disabled'
            }
        }
    },
    methods: {
        click() {
            if (!this.disabled) {
                this.$emit('click')
            }
        }
    }
}
</script>

<template>
    <span class="Btn" :class="btnClass" @click="click" >
        <slot></slot>
    </span>
</template>

<style lang="scss" scoped>
@import './css/color.scss';
@import './css/common.scss';
.Btn {
    background-color: $mainPurple;
    color: #fff;
    cursor: pointer;
    border-radius: 2px;
    &:hover {
        background-color: #00ADC7;
    }
    @extend %center;
}
.disabled {
    background-color: #dadada;
    cursor: not-allowed;
    &:hover {
        background-color:  #00ADC7;
    }
}
</style>





// WEBPACK FOOTER //
// yotta-vue-components/vision/Btn.vue